import { render, staticRenderFns } from "./AssetDetail.html?vue&type=template&id=8f10edf8&scoped=true&"
import script from "./AssetDetail.js?vue&type=script&lang=js&"
export * from "./AssetDetail.js?vue&type=script&lang=js&"
import style0 from "./AssetDetail.scss?vue&type=style&index=0&id=8f10edf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f10edf8",
  null
  
)

export default component.exports